<template>
  <div class="stepContent">
    <el-row>
      <el-col :span="14">
        <el-card shadow="nerver" class="box-card" :body-style="{padding: 0}">
          <el-row>
            <el-col :span="18">
              <el-form ref="model" :model="model" :rules="rules" label-width="100px" label-position="right">
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="占位类型：" prop="courseType">
                      <el-select v-model="model.courseType"
                                 :disabled="dataIn.isCompleted"
                                 size="medium"
                                 placeholder="请选择占位类型"
                                 @change="onCourseTypeChange">
                        <el-option v-for="item in courseTypeList"
                                   :key="item.Key"
                                   :label="item.Value"
                                   :value="item.Key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="优惠政策：">
                      <el-select v-model="model.selectedDiscountList" placeholder="请选择优惠政策" multiple :disabled="dataIn.isCompleted" @input="onDiscountsInput">
                        <el-option v-for="item in discountListDisplayed" :key="item.Id" :label="item.LabelName" :value="item.Id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="model.courseType == 1">
                  <el-col :span="20">
                    <el-form-item label="占位规则：">
                      <el-select placeholder="请选择占位规则" :disabled="dataIn.isCompleted" v-model="model.selectedAdvanceEnrollmentId" @input="onAEListInput" >
                        <!--<el-option v-for="ae in universityAdvanceEnrollmentList" v-if="ae.UniversityId == currentStudent.UniversityId" :key="ae.Key" :value="ae.Key">-->

                        <el-option v-for="ae in universityAdvanceEnrollmentList" v-if="ae.UniversityId == currentStudent.UniversityId && ae.Enable" :label="'定金: '+ae.Amount + '$ | 折扣: ' +ae.Discount+' % ' + ae.Comment" :key="ae.Key" :value="ae.Id">
                          定金: {{ae.Amount}} $ | 折扣: {{ae.Discount}} % {{ae.Comment}}
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                 <el-row v-if="model.courseType == 3">
                  <el-col :span="20">
                    <el-form-item label="占位单价：">
                      {{trainingAdEnrollmentPrice}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="占位课数：" prop="advanceEnrollmentCount">
                      <el-input placeholder="请输入占位课数" v-model="model.advanceEnrollmentCount" :disabled="dataIn.isCompleted" class="input-width" @input="onAECountInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="占位价格：">
                      <span class="input-width">{{dataIn.priceData.totalPrice|toCurrency}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="20">
                    <el-form-item label="合同" prop="contractId">
                      <el-select v-model="model.contractId" placeholder="请选择合同" :disabled="dataIn.isCompleted" @input="onContractIdInput" :clearable="true">
                        <el-option v-for="item in contractList" :key="item.Value" :label="item.Text" :value="item.Value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
            <el-col :span="6" class="sub-total">
              <el-row>
                <el-col>
                  <span>小计</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col>{{dataIn.priceData.discountPrice|toCurrency}}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.box-card {
  background-color: #f5f7fa;

  .el-row {
    padding-left: 18px;
  }

  .el-form {
    padding: 20px;
  }

  .sub-total {
    background-color: #e1edf7;
    height: 390px;
    text-align: center;
    padding-top: 120px;

    .el-row {
      padding-left: 0px;

      .el-col {
        span {
          padding-left: 0px;
        }
      }
    }
  }
}

.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
  }

  button {
    line-height: 8px;
    margin-top: 5px;
    margin-left: 10px;
  }
}
</style>

<script>
  import { getContractList } from "@/service/contract.service";
  import { getStudent } from "../../../service/student.service";
import {  getUniversityAdvanceEnrollments } from "../../../service/advanceEnrollment.service";

export default {
  props: {
    isCalculating: Boolean,
    studentId:Number | String,
    dataIn: {
      isCompleted: Boolean,
      hasBuyMemberCard: Boolean,
      priceSettings:Object,
      modelData:{
        courseType: Number,
        selectedDiscountList: Array,
        advanceEnrollmentCount: Number,
        contractId: Number,
        studentId: Number

      },
      priceData:{
        totalPrice:Number,
        discountPrice:Number
      }
    },
    discountListData:{
      discountList:Array,
      trainingDiscountList:Array,
    }
  },
  data() {
    let validateAECount = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的占位课数";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      discountList:null,
      trainingDiscountList:null,
      discountListDisplayed:[],
      contractList: [],
      hasBuyMemberCard: false,
      totalPrice:0,
      discountPrice: 0,
      trainingAdEnrollmentPrice:0,
      currentStudent: {},
      universityAdvanceEnrollmentList : [],
      model:{
        courseType: "",
        selectedDiscountList: [],
        advanceEnrollmentCount: 0,
        contractId: null,
        selectedAdvanceEnrollmentId:""
      },
      courseTypeList:[{Key:1, Value:"大学补习"},{Key:3, Value:"职业培训"}],
      rules: {
        advanceEnrollmentCount: [
          {
            validator: validateAECount,
            trigger: "blur"
          }
        ],
        courseType:[
          {
            required: true,
            message: "占位类型是必须的",
            trigger: "blur"
          }
        ],
        // contractId:[
        //   {
        //     required: true,
        //     message: "合同是必须的",
        //     trigger: "blur"
        //   }
        // ]
      }
    };
  },
  components: {},
  computed: {
    defaultContractId() {
      let item = this.universityAdvanceEnrollmentList.find(item => item.Id === this.model.selectedAdvanceEnrollmentId);
      return !!item ? item.ContractId : null;
    }
  },
  created() {
    this.loadContractList();
    this.init();
    this.loadStudentInfo();
    this.loadUniversityAdvanceEnrollments();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.modelData){
        this.model = this.dataIn.modelData;
        this.totalPrice = this.dataIn.totalPrice;
        this.discountPrice = this.dataIn.discountPrice;   
        // if (!this.dataIn.modelData.contractId && this.contractList && this.contractList.length > 0){
        //   this.model.contractId = this.contractList[0].Value;
        // } 
        this.trainingAdEnrollmentPrice = this.dataIn.priceSettings.trainingAdEnrollmentPrice;
      }else{
        this.model =  {
          courseType: "",
          selectedDiscountList: [],
          advanceEnrollmentCount: 0,
          contractId: null,
        };
      }
      this.getDiscountListDisplayed();
    },
    checkAllInputs() {
      let isValid = true;

      let $ref = this.$refs["model"];
      if (!!$ref) {
        $ref.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      return isValid && this.model.advanceEnrollmentCount !== "";
    },
    getDiscountListDisplayed() {
      if (!this.discountList || !this.trainingDiscountList){
        return;
      }

      let displayList = [];
      let list = this.discountList;
      if (!!this.model && this.model.courseType == 3){
        list = this.trainingDiscountList;
      }
      list.forEach(item => {
        let isAdd = true;
       
        if (item.MapVariableName == "MembershipCardDiscountPrice"){
          if (!this.dataIn.hasBuyMemberCard && 
            !this.model.selectedDiscountList.find(i=> i == item.Id)){
            isAdd = false;
          }
        }
        if (isAdd) {
          displayList.push(item);
        }
      });
  
      this.discountListDisplayed = displayList;
    },
    loadContractList() {
      getContractList(1).then(result => {
        if (!!result && result.success) {
          this.contractList = result.data;

          // if (!!this.dataIn && !!this.dataIn.modelData && !this.dataIn.modelData.contractId && this.contractList.length > 0){
          //   this.model.contractId = this.contractList[0].Value;
          // } 
        }
      });
    },
    async loadStudentInfo() {
      if (!this.model.studentId){
        return;
      }
      let result = await getStudent(this.model.studentId)
      if (!!result && result.success) {
        this.currentStudent = result.data;
      }

    },
    async loadUniversityAdvanceEnrollments() {
      getUniversityAdvanceEnrollments().then(result => {
        if (!!result && result.success) {
          this.universityAdvanceEnrollmentList = result.data;
        }
      });

    },
    onContractIdInput(){

    },
    onCourseTypeChange(){
      this.getDiscountListDisplayed();
      this.model.selectedDiscountList = [];
      this.model.advanceEnrollmentCount = 0;
      this.model.selectedAdvanceEnrollmentId = "";
      //this.model.contractId = "";
      this.triggerCalculate();
    },
    onDiscountsInput() {
      this.triggerCalculate();
    },
    onAECountInput() {
      this.triggerCalculate();
    },
    onAEListInput() {
      let setByDefault = false;
      if (!!this.defaultContractId){
        let index = this.contractList.findIndex(i => i.Value === this.defaultContractId);
        if (index >=0 ){
          this.model.contractId = this.defaultContractId;
          setByDefault = true;
        }
      }
      
      if (!setByDefault){
        // if (this.contractList.length > 0)
        //   this.model.contractId = this.contractList[0].Value;
        // else
          this.model.contractId = null;
      }
      this.triggerCalculate();
    },
    triggerCalculate() {
      this.$emit("calculate");
    },
  },
  watch: {
    dataIn: function() {
      this.init();
      this.loadStudentInfo();
    },
    discountListData: function(){
      if (!!this.discountListData){
        this.discountList = this.discountListData.discountList;
        this.trainingDiscountList = this.discountListData.trainingDiscountList;
        this.getDiscountListDisplayed();
      } 
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/advanceEnrollmentFee/aefWorkflowStep2.vue